import { Clock8Icon } from 'lucide-react';

import { cn } from '@/lib/utils';

import { TimeLineBox } from './TimelineBox';

import styles from './Versions.module.scss';

export const VersionTimeline = ({ version, isLast, index, versions }) => {
  return (
    <div className={cn('relative flex', styles.timeLine)}>
      <div className="relative flex flex-col items-center">
        <div className="my-0.5 flex size-5 items-center justify-center">
          <Clock8Icon size={16} className="text-muted-foreground" />
        </div>
        {!isLast && <div className="w-px flex-1 bg-border" />}
      </div>
      <div className={cn('flex-1', styles.timeLineContent)}>
        <TimeLineBox version={version} index={index} versions={versions} />
      </div>
    </div>
  );
};
